export class COInvoiceValidation {
  constructor(dom, payment, formattedPaymentAmount) {
    this.dom = dom;
    this.payment = payment;
    this.formattedPaymentAmount = formattedPaymentAmount;

    const doc = this.dom.documentElement;
    this.invoiceTag = (doc.nodeName === "AttachedDocument") ?
      this.extractInvoiceFromAttachment(doc) : doc;
  }

  validate() {
    console.log("=> Colombia Invoice : ", this.dom.documentElement.nodeName);

    return this.validateInvoice();
  }

  receiptType() {
    return "invoice";
  }

  get fiscalID() {
    const parentTags = this.invoiceTag.getElementsByTagName("cac:AccountingSupplierParty");

    if (parentTags.length === 0) {
      return undefined;
    }

    const companyIDTags = parentTags[0].getElementsByTagName("cbc:CompanyID");

    if (parentTags.length === 0) {
      return undefined;
    }

    return companyIDTags[0].textContent;
  }

  get fitpassFiscalID() {
    const parentTags = this.invoiceTag.getElementsByTagName("cac:AccountingCustomerParty");

    if (parentTags.length === 0) {
      return undefined;
    }

    const companyIDTags = parentTags[0].getElementsByTagName("cbc:CompanyID");

    if (parentTags.length === 0) {
      return undefined;
    }

    return companyIDTags[0].textContent;
  }

  /**
   * @param doc HTMLElement
   */
  extractInvoiceFromAttachment(doc) {
    let tags = doc.getElementsByTagName("cac:ExternalReference");
    if (tags.length === 0) {
      return;
    }

    tags = tags[0].getElementsByTagName("cbc:Description");
    if (tags.length === 0) {
      return;
    }
    const xml = tags[0].textContent;
    const cleanedXML = xml.replace('<![CDATA[', '').replace(']]>', '');
    const domParser = new DOMParser();
    return domParser.parseFromString(cleanedXML, "application/xml").documentElement;
  }

  validateInvoice() {
    console.group("invoiceTag");
    console.log(this.invoiceTag);
    console.groupEnd();

    if (this.invoiceTag == null) {
      return {
        error: true,
        message: `Archivo XML inválido, Invoice tag no encontrado`
      };
    }

    console.log("Checking Fitpass fiscal ID", this.fitpassFiscalID);

    // if (this.fitpassFiscalID !== "901397400") {
    //   return { error: true,
    //            message: `La factura no coincide con nuestros datos fiscales... Fitpass SAPI de CV, RFC FIT151125976. Favor de revisarlos. Gracias`};
    // }

    console.log("Checking Fiscal ID", this.fiscalID);
    if (this.fiscalID == null) {
      return {
        error: true,
        message: `Archivo XML inválido, NIT Emisor no encontrado`
      };
    }

    const amountTags = this.invoiceTag.getElementsByTagName("cbc:PayableAmount");
    if (amountTags.length === 0) {
      return {error: true, message: "Archivo XML inválido. Monto no encontrado"};
    }

    return this.validateAmount(parseInt(amountTags[0].textContent, 10));
    // return {error: true, message: "not implemented yet"};
  }

  validateAmount(amount) {
    const min = Math.trunc(this.payment) - 5;
    const max = Math.trunc(this.payment) + 5;
    const truncAmount = Math.trunc(amount);

    console.log("=> Amounts min: ", min, " value: ", truncAmount, " max: ", max);

    const formattedAmount = new Intl.NumberFormat(
      "es-CO",
      {
        style: "currency",
        currency: "COP",
      }
    ).format(amount);

    if (truncAmount < min || truncAmount > max) {
      return {
        error: true, message: `
        Monto de la factura no coincide, ${formattedAmount},
        les recordamos que el monto total del reporte de visitas Fitpass incluye IVA.
        Para dudas adicionales, favor de enviar correo a contacto@fitpass.co
      `.trim()
      };
    }

    return {error: false, message: ""};
  }
}
